module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Add Rewards Bazaar Items',
        subTitle: `<b>${vars[0]}</b> added for Get It Shipped`
    };

    return resources[label];
};
